/**
 * Checks if a value is undefined.
 *
 * @param val - The value to check.
 * @returns A boolean indicating whether the value is undefined or not.
 */
export function isUndefined(val: unknown): val is undefined {
  return val === undefined
}
